import { Button, IButton } from '@picsart/button';
import IconCopy from '@picsart/icons/IconCopy';
import { MouseEventHandler, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonSkinStatusSuccess } from '@picsart/button/skins';

function CopyButton({ onClick, skin, ...props }: IButton) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const handleClick: MouseEventHandler<HTMLAnchorElement | HTMLButtonElement | HTMLLabelElement> = (
    e,
  ) => {
    setCopied(true);
    onClick(e);
    setTimeout(() => {
      setCopied(false);
    }, 3000);
  };

  return (
    <Button
      {...props}
      type="button"
      startIcon={IconCopy}
      onClick={handleClick}
      skin={copied ? ButtonSkinStatusSuccess : skin}
    >
      {copied ? t('editor.results.copied') : t('editor.results.copyButton')}
    </Button>
  );
}
export default CopyButton;
